import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { basePathCurrentEnv } from '@utils/Navigation/basePathCurrentEnv.utils';
import { lastValueFrom, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly _httpClient = inject(HttpClient);

  getDiscountModal(discount: string) {
    const obs$ = this._httpClient
      .get(`${basePathCurrentEnv()}PromoDetails/${discount}/modal-promo.txt`, {
        responseType: 'text',
      })
      .pipe(
        tap((res) => {
          if (!res) throw new Error(`No Modal for ${discount}`);
        }),
      );

    return lastValueFrom(obs$);
  }

  getCookiePolicy() {
    const obs$ = this._httpClient
      .get(`${basePathCurrentEnv()}CookiePolicy/cookie-policy.txt`, {
        responseType: 'text',
      })
      .pipe(
        tap((res) => {
          if (!res) throw new Error(`No Modal for `);
        }),
      );

    return lastValueFrom(obs$);
  }

  getPrivacyPolicy() {
    const obs$ = this._httpClient
      .get(`${basePathCurrentEnv()}PrivacyPolicy/privacy-policy.txt`, {
        responseType: 'text',
      })
      .pipe(
        tap((res) => {
          if (!res) throw new Error(`No Modal for `);
        }),
      );

    return lastValueFrom(obs$);
  }

  getVaxruleModal(vaxrule: string) {
    const obs$ = this._httpClient
      .get(`${basePathCurrentEnv()}PromoDetails/VAXRULE/modal-vaxrule-${vaxrule}.txt`, {
        responseType: 'text',
      })
      .pipe(
        tap((res) => {
          if (!res) throw new Error(`No Modal for ${vaxrule}`);
        }),
      );

    return lastValueFrom(obs$);
  }

  getPaxTypeModal(paxtype: string) {
    let basePath = `${basePathCurrentEnv()}PaxTypeDetails/NP/${paxtype}/modal-promo.txt`;
    if (window.marketCode === 'FI') { //TODO: potrebbe diventare dinamico per tutto en-BZ
      basePath = `${basePathCurrentEnv()}PaxTypeDetails/NP/FI/${paxtype}/modal-promo.txt`;
    }
    const obs$ = this._httpClient
      .get(basePath, {
        responseType: 'text',
      })
      .pipe(
        tap((res) => {
          if (!res) throw new Error(`No Modal for ${paxtype}`);
        }),
      );

    return lastValueFrom(obs$);
  }

  getPromoAlertModal(promo: string) {
    const obs$ = this._httpClient
      .get(`${basePathCurrentEnv()}PaxTypeDetails/PromoAlert/${promo}/modal-promo.txt`, {
        responseType: 'text',
      })
      .pipe(
        tap((res) => {
          if (!res) throw new Error(`No Modal for ${promo}`);
        }),
      );

    return lastValueFrom(obs$);
  }
}
